<template>
    <div class="container">
        <Row :gutter="48">
            <Col span="12">
                <div class="d-block">
                    <h1 class="d-flex mb-lg">
                        <span class="d-flex justify-center square-48 radius-all bd-1 b-success">
                            <img alt="" src="static/icon/icon-logo-green@256px.svg" width="28"/>
                        </span>
                        <span class="d-flex-item pl-sm">{{ lang === 'zh-cn' ? '北京源音文创科技股份有限公司' : 'Beijing Anystage Cultural Creative Technology Co.,Ltd' }}</span>
                    </h1>
                    <h2 class="d-flex mb-lg">
                        <span class="d-flex justify-center square-48 radius-all bd-1 b-success">
                            <Icon type="md-pin" size="28" color="#13aa52"/>
                        </span>
                        <span class="d-flex-item pl-sm">{{ lang === 'zh-cn' ? '北京市海淀区安宁庄西路9号院25号楼7层3-726A （地铁13号线清河地铁站东广场出口）' : 'Room 3-726A, Building 25, No.9 Yard, An Ningzhuang West Road, HaiDian District, Beijing, China （East Plaza Exit at Qing He Station of Subway Line 13,）' }}</span>
                    </h2>
                    <h2 class="d-flex justify-start mb-lg">
                        <span class="d-flex justify-center square-48 radius-all bd-1 b-success">
                            <Icon type="ios-call" size="28" color="#13aa52"/>
                        </span>
                        <span class="d-flex-item pl-sm">+86 010-82827993</span>
                    </h2>
                    <h2 class="d-flex justify-start mb-lg">
                        <span class="d-flex justify-center square-48 radius-all bd-1 b-success">
                            <Icon type="ios-mail" size="28" color="#13aa52"/>
                        </span>
                        <span class="d-flex-item pl-sm">info@yuanyin.com</span>
                    </h2>
                </div>
            </Col>
            <Col span="12">
                <form class="comments-form" v-model="commentForm">
                    <div class="form-item">
                        <h3 class="d-block width-100">{{ lang === 'zh-cn' ? '姓名：' : 'Name:' }}</h3>
                        <div class="d-flex-item">
                            <input type="text" v-model="commentForm.name"/>
                        </div>
                    </div>
                    <div class="form-item">
                        <h3 class="d-block width-100">{{ lang === 'zh-cn' ? '联系电话：' : 'Phone:' }}</h3>
                        <div class="d-flex-item">
                            <input type="text" v-model="commentForm.phone"/>
                        </div>
                    </div>
                    <div class="form-item">
                        <h3 class="d-block width-100">{{ lang === 'zh-cn' ? '邮箱地址：' : 'Email:' }}</h3>
                        <div class="d-flex-item">
                            <input type="text" v-model="commentForm.email"/>
                        </div>
                    </div>
                    <div class="form-item">
                        <h3 class="d-block width-100">{{ lang === 'zh-cn' ? '主题：' : 'Subject:' }}</h3>
                        <div class="d-flex-item">
                            <input type="text" v-model="commentForm.subject"/>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="d-flex-item">
                            <textarea rows="4" v-model="commentForm.content"/>
                        </div>
                    </div>
                    <br/>
                    <h6>
                        <a class="btn" @click="submitComment(commentForm)">{{ lang === 'zh-cn' ? '提交留言' : 'Submit Comment' }}</a>
                    </h6>
                </form>
            </Col>
        </Row>
    </div>
</template>

<script type="text/javascript">
    export default {
        props: {
            lang: {
                type: String,
            },
            useType: {
                type: String,
            }
        },
        data () {
            return {
                commentForm: {
                    name: "",
                    phone: "",
                    email: "",
                    subject: "",
                    content: ""
                },
            }
        },
        mounted() {
        },
        methods: {
            isPone(pone){
                var _pone = /^[1][3,4,5,7,8][0-9]{9}$/;
                if (!_pone.test(pone)) {
                    return false;
                } else {
                    return true;
                }
            },
            isEmail(email){
                var _email = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
                if (!_email.test(email)) {
                    return false;
                } else {
                    return true;
                }
            },
            submitComment(data){
                console.log(data);
                if (data.phone !== ''){
                    if (this.isPone(data.phone) === false){
                        this.$Message.error(this.lang === 'zh-cn' ? '手机号格式错误' : 'Malformed phone number');
                        return false;
                    }
                } else {
                    this.$Message.error(this.lang === 'zh-cn' ? '手机号不能为空' : 'Phone number cannot be empty');
                    return false;
                }

                if (data.email !== ''){
                    if (this.isEmail(data.email) === false){
                        this.$Message.error(this.lang === 'zh-cn' ? '邮箱格式错误' : 'Malformed Email Address');
                        return false;
                    }
                } else {
                    this.$Message.error(this.lang === 'zh-cn' ? '邮箱不能为空' : 'Email number cannot be empty');
                    return false;
                }
                if (data.content === ''){
                    this.$Message.error(this.lang === 'zh-cn' ? '内容不能为空' : 'Content cannot be empty');
                }

                this.$Spin.show();
                this.$api.postHttp('feedback', {
                    name: data.name,
                    phone: data.phone,
                    email: data.email,
                    subject: data.subject,
                    content: data.content,
                },{
                    // Authorization: this.$store.state.accountData.token,
                    language: this.language,
                }).then(res=>{
                    // console.log('<---------- res ---------->');
                    // console.log(res);
                    if (res.status === 200){
                        this.$Spin.hide();
                        this.$Modal.success({
                            title: this.lang === 'zh-cn' ? '提示' : 'Tips',
                            content: this.lang === 'zh-cn' ? '留言已收到，我们会尽快联系您！' : 'The message has been received, we will contact you as soon as possible!',
                            okText: this.lang === 'zh-cn' ? '确定' : 'Enter',
                        });
                        this.commentForm = {
                            name: "",
                            phone: "",
                            email: "",
                            subject: "",
                            content: ""
                        };
                    }
                    if (this.useType === 'pages'){
                        // todo
                    } else if (this.useType === 'modal'){
                        this.$bus.emit('isComments', false);
                    }
                }).catch(err=>{
                    console.log(err.msg);
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/OnlineConsultative.vue